import React from 'react';

const SyncIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 512 512"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M370.7 133.3C339 101.6 296.4 84 252 84c-79.5 0-147.1 54.1-167.4 128h48.6c17.4-48.1 63.2-80 118.8-80 33.4 0 64.3 13 87.7 36.3L296 212h160V52l-40.6 40.6zM260 428c79.5 0 147.1-54.1 167.4-128h-48.6c-17.4 48.1-63.2 80-118.8 80-33.4 0-64.3-13-87.7-36.3L216 300H56v160l40.6-40.6C173 410.4 215.6 428 260 428z" />
  </svg>
);
export default SyncIcon;
